<ul class="navbar-nav">
    <!-- <li>
        <div class="dropdown" ngbDropdown placement="auto">
        <a ngbDropdownToggle href="javascript:" data-toggle="dropdown"><i class="icon feather icon-bell"></i></a>
        <div ngbDropdownMenu class="dropdown-menu dropdown-menu-right notification">
            <div class="noti-head">
            <h6 class="d-inline-block m-b-0">Notifications</h6>
            <div class="float-right">
                <a href="javascript:" class="m-r-10">mark as read</a>
                <a href="javascript:">clear all</a>
            </div>
            </div>
            <ul class="noti-body">
            <li class="n-title">
                <p class="m-b-0">NEW</p>
            </li>
            <li class="notification">
                <div class="media">
                <img class="img-radius" src="assets/images/user/avatar-1.jpg" alt="Generic placeholder image">
                <div class="media-body">
                    <p><strong>John Doe</strong><span class="n-time text-muted"><i class="icon feather icon-clock m-r-10"></i>now</span></p>
                    <p>New ticket Added</p>
                </div>
                </div>
            </li>
            <li class="n-title">
                <p class="m-b-0">EARLIER</p>
            </li>
            <li class="notification">
                <div class="media">
                <img class="img-radius" src="assets/images/user/avatar-2.jpg" alt="Generic placeholder image">
                <div class="media-body">
                    <p><strong>Joseph William</strong><span class="n-time text-muted"><i class="icon feather icon-clock m-r-10"></i>10 min</span></p>
                    <p>Prchace New Theme and make payment</p>
                </div>
                </div>
            </li>
            <li class="notification">
                <div class="media">
                <img class="img-radius" src="assets/images/user/avatar-3.jpg" alt="Generic placeholder image">
                <div class="media-body">
                    <p><strong>Sara Soudein</strong><span class="n-time text-muted"><i class="icon feather icon-clock m-r-10"></i>30 min</span></p>
                    <p>currently login</p>
                </div>
                </div>
            </li>
            </ul>
            <div class="noti-footer">
            <a href="javascript:">show all</a>
            </div>
        </div>
        </div>
    </li> -->
    <!-- <li (click)="this.visibleUserList = !this.visibleUserList;"><a href="javascript:" class="displayChatbox"><i class="icon feather icon-mail"></i></a></li> -->
    <li *ngIf="env != Constants.PROD">
        <span 
          *ngIf="currentEnv" class="badge badge-pill badge px-2 pt-1"
          [ngClass]="[env === Constants.DEV ? 'badge-dev' : 'badge-test']">
          {{ currentEnv }}
        </span>
      </li>
    <li>
        <div class="dropdown drp-user" ngbDropdown placement='auto'>
            <a href="javascript:" ngbDropdownToggle data-toggle="dropdown">
                <i class="icon feather icon-settings"></i>
            </a>
            <div class="dropdown-menu dropdown-menu-right profile-notification" ngbDropdownMenu>
                <div class="pro-head">
                <!-- <img src="assets/images/user/avatar-1.jpg" class="img-radius" alt="User-Profile-Image"> -->
                <!--TODO: fix the user-initial class-->
                <!-- <span class="user-initial" *ngIf="portalUser">{{this.portalUser.firstName.charAt(0)}}{{this.portalUser.lastName.charAt(0)}}</span> -->
                <span *ngIf="portalUser">{{this.portalUser.firstName}} {{this.portalUser.lastName}}</span>
                    <!-- <a href="javascript:" (click)="onLogOut()" class="dud-logout" title="Logout">
                        <i class="feather icon-log-out"></i>
                    </a> -->
                </div>

                <div class="theme-border">
                    <div class="theme-content">
                        <div class="small form-text"><label class="header">App Info</label></div>
                        <div class="small form-text"><label class="header">Version</label>: {{currentAppVersion}}</div>
                        <div class="small form-text"><label class="header">Build</label>: {{buildVersion}}</div>
                    </div>
                </div>

                <ul class="pro-body">
                    <!-- <li><a href="javascript:" class="dropdown-item"><i class="feather icon-user"></i> Profile</a></li> -->
                    <!-- <li><a href="javascript:" class="dropdown-item"><i class="feather icon-settings"></i> Settings</a></li> -->
                    <!-- <li><a href="javascript:" class="dropdown-item"><i class="feather icon-mail"></i> My Messages</a></li> -->
                    <!-- <li><a href="javascript:" class="dropdown-item"><i class="feather icon-lock"></i> Lock Screen</a></li> -->
                    <li><a href="javascript:" (click)="onLogOut()" class="dropdown-item"><i class="feather icon-log-out text-primary"></i> <span class="text-primary">Logout</span></a></li>
                </ul>
            </div>
        </div>
    </li>
</ul>
<!--
<section class="header-user-list" *ngIf="visibleUserList && !this.appConfig['rtlLayout']" [ngClass]="{'open': visibleUserList}" [@slideInOutLeft]>
    <app-chat-user-list (onChatToggle)="onChatToggle($event)" (onChatCollapse)="this.visibleUserList = !this.visibleUserList; this.chatMessage = false;"></app-chat-user-list>
</section>

<section class="header-chat" *ngIf="chatMessage && !this.appConfig['rtlLayout']" [ngClass]="{'open': chatMessage}" [@slideInOutLeft]>
    <app-chat-msg (onChatToggle)="this.chatMessage = !this.chatMessage" [friendId]="friendId"></app-chat-msg>
</section>

<section class="header-user-list" *ngIf="visibleUserList && this.appConfig['rtlLayout']" [ngClass]="{'open': visibleUserList}" [@slideInOutRight]>
    <app-chat-user-list (onChatToggle)="onChatToggle($event)" (onChatCollapse)="this.visibleUserList = !this.visibleUserList; this.chatMessage = false;"></app-chat-user-list>
</section>

<section class="header-chat" *ngIf="chatMessage && this.appConfig['rtlLayout']" [ngClass]="{'open': chatMessage}" [@slideInOutRight]>
    <app-chat-msg (onChatToggle)="this.chatMessage = !this.chatMessage" [friendId]="friendId"></app-chat-msg>
</section> -->
